module.exports = __webpack_public_path__ + "img/products_big_can_extra.a7450f28.png";